import {  Col, Input, Label, Row} from "reactstrap"
import { IUserQuestionnaireQuestionWithAnswer, UserFeedbackAnswer } from "../../interfaces/contentManagement/UserQuestionnaireWithAnswerOptions";
import { useRef } from "react";
interface Props {
    questionnaires : IUserQuestionnaireQuestionWithAnswer;
    handleAnswers : (answers : UserFeedbackAnswer[]) => void;
}


export default function QuestionnaireQuestionBlock({ handleAnswers, questionnaires }: Props) {

    const userAnswers  = useRef<UserFeedbackAnswer[]>([]);

    const HandleOnChange = (questionId : string , answerId : string , answerLabel : string) => {
        const getIndex = userAnswers.current.findIndex(u => u.question_id === questionId);
        if(getIndex === -1) {
            userAnswers.current.push({ question_id : questionId, answer_id : answerId, answer_label : answerLabel });
        } else {
            userAnswers.current[getIndex].answer_id = answerId;
            userAnswers.current[getIndex].answer_label = answerLabel;
        }
        handleAnswers(userAnswers.current);
    }

    return (
        <div>
            {
                questionnaires.questions.map((item, key) => 
                
                    <div key={key}>
                        <div className="d-flex justify-content-between mb-2">
                            <h4>Question {key + 1}</h4>
                        </div>
                        <div>
                            {item.question}
                        </div>
                        <Row className="p-3">
                            {
                                    item.answer_details.answers.map((opt, optKey) => 
                                    <Col key={optKey}>
                                        <div className="">
                                            <Input 
                                                type="radio" readOnly name={`${key}_question`} 
                                                id={`${key}_question_${optKey}`} value={opt._id} 
                                                onChange={() => { HandleOnChange(item._id, opt._id, opt.label); }} className="mt-2" 
                                            />
                                            <Label for={`${key}_question_${optKey}`}>{opt.label}</Label>
                                        </div>
                                    </Col>
                                )
                            }
                        </Row>

                    </div>
                )
            }
        </div>
    )
}